<template>
  <section class="official">
    <div class="wrap">
      <div class="phone">
        <img class="phone-img" src="@/assets/images/movil.png" alt="App Bienestar Azteca" />
      </div>
      <div class="text">
        <h2>Comunicado oficial:</h2>
        <br />
        <p class="desktop-text">
          Banco Azteca Institución de Banca Múltiple S.A de C.V informa que se <br />
          tomó la decisión de concluir las operaciones de la aplicación <br />
          <strong>Bienestar Azteca Digital.</strong> Por lo anterior la App dejará de estar<br />
          disponible para su uso y descarga a partir del <strong>15 de abril 2026</strong>.<br />
          Esta decisión responde a una reorientación estratégica del proyecto<br />
          y no afecta los compromisos previamente adquiridos con usuarios y <br />
          aliados institucionales.<br />
          Reiteramos nuestro compromiso con la protección de información,<br />
          la atención responsable y el cumplimiento de las disposiciones<br />
          legales aplicables.<br />
        </p>
        <p class="mobile-text">
          Banco Azteca Institución de Banca Múltiple S.A de C.V informa que se
          tomó la decisión de concluir las operaciones de la aplicación
          <strong>Bienestar Azteca Digital.</strong> Por lo anterior la App dejará de estar
          disponible para su uso y descarga a partir del <strong>15 de abril 2026</strong>.
        </p>
        <p class="mobile-text">
          Esta decisión responde a una reorientación estratégica del proyecto
          y no afecta los compromisos previamente adquiridos con usuarios y
          aliados institucionales.
        </p>
        <p class="mobile-text">
          Reiteramos nuestro compromiso con la protección de información,
          la atención responsable y el cumplimiento de las disposiciones
          legales aplicables.
        </p>
        <p class="more-info">
          Para más información consulta en el sitio de Banco Azteca el apartado
          de folletos y legales:
          <a href="https://www.bancoazteca.com.mx/productos/cuentas/programa-bienestar.html"
            target="_blank" rel="noreferrer noopener" class="info-link">
            https://www.bancoazteca.com.mx/productos/cuentas/programa-bienestar.html
          </a>
        </p>
        <br />
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>
.official {
  background: #fff;
  padding: 60px 16px 10px;
}

.wrap {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 42px;
  align-items: center;
}

.phone {
  display: flex;
  justify-content: center;
}

.phone-img {
  width: 100%;
  max-width: 360px;
  height: auto;
}

.text {
  text-align: left;
  max-width: 680px;
  margin-left: 0;
  margin-top: -20px;
}

.text h2 {
  margin: 0 0 20px;
  font-size: 35px;
  font-weight: 900;
  text-align: left;
}

.text p {
  margin: 0 0 16px;
  color: #181818;
  line-height: 1.6;
  font-size: 18.4px;
  text-align: justify;
}

.date {
  margin-top: 18px;
  color: #777;
}

.more-info {
  margin-top: 24px;
  padding: 16px 20px;
  background: #f5faf0;
  border-left: 4px solid #17A54D;
  border-radius: 0 8px 8px 0;
  font-size: 17px !important;
  color: #333 !important;
  line-height: 1.6;
  text-align: left !important;
}

.info-link {
  display: block;
  margin-top: 8px;
  color: #17A54D;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.2s ease;
}

.info-link:hover {
  color: #0d7a35;
}

.desktop-text {
  display: block;
}

.mobile-text {
  display: none;
}

/* ── Tablet ──────────────────────────────────────────────────── */
@media (max-width: 900px) {
  .wrap {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .phone {
    margin-bottom: 40px;
  }

  .phone-img {
    max-width: 300px;
  }

  .text {
    margin-top: 0;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 90%;
  }

  .text h2 {
    text-align: center;
    margin-bottom: 15px;
  }

  .text p {
    text-align: center;
    line-height: 1.7;
  }

  .desktop-text {
    display: none;
  }

  .mobile-text {
    display: block;
    margin-bottom: 15px;
  }

  .date {
    text-align: center;
  }

  .more-info {
    text-align: left;
    border-left: 4px solid #17A54D;
    font-size: 16px !important;
    padding: 14px 18px;
  }

  .info-link {
    display: block;
    margin-top: 6px;
    font-size: 15px;
  }
}

/* ── Móvil ───────────────────────────────────────────────────── */
@media (max-width: 600px) {
  .phone {
    margin-bottom: 30px;
  }

  .phone-img {
    max-width: 280px;
  }

  .text h2 {
    font-size: 28px;
    margin-bottom: 12px;
  }

  .text p {
    font-size: 16px;
    line-height: 1.65;
  }

  .mobile-text {
    margin-bottom: 18px;
  }

  .more-info {
    font-size: 14px !important;
    padding: 12px 14px;
    margin-top: 16px;
    border-radius: 0 6px 6px 0;
  }

  .info-link {
    display: block;
    margin-top: 6px;
    font-size: 14px;
    word-break: break-word;
  }
}

@media (max-width: 400px) {
  .text h2 {
    font-size: 24px;
  }

  .text p {
    font-size: 15px;
    line-height: 1.6;
  }

  .mobile-text {
    margin-bottom: 15px;
  }

  .more-info {
    font-size: 13px !important;
    padding: 10px 12px;
  }

  .info-link {
    font-size: 13px;
  }
}
</style>